import { toast } from "react-toastify";

export const toastSuccess = async (params) => {
  return toast.success(params);
};

export const toastError = async (params) => {
  return toast.error(params);
};
